import queryString from "query-string";

const generateUrl = (url, title, description) => {
  return {
    facebook:
      `https://www.facebook.com/sharer/sharer.php?` +
      queryString.stringify({
        u: url
      }),
    twitter:
      `https://twitter.com/intent/tweet?` +
      queryString.stringify({
        url,
        text: title
      }),
    vk:
      `https://vk.com/share.php?` +
      queryString.stringify({
        url
      }),
    linkedin:
      `https://www.linkedin.com/shareArticle?` +
      queryString.stringify({
        mini: true,
        url,
        title,
        summary: description
      }),
    googlePlus:
      `https://plus.google.com/share` +
      queryString.stringify({
        url
      }),
    email:
      `mailto:?` +
      queryString.stringify({
        subject: title,
        body: url + "\n" + description
      })
  };
};

export default generateUrl;
